import { render, staticRenderFns } from "./EchartsChart.vue?vue&type=template&id=50a4b0b8"
import script from "./EchartsChart.vue?vue&type=script&lang=js"
export * from "./EchartsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports